<div class="container-box">
  <app-loading-section *ngIf="isLoading"></app-loading-section>
  <div *ngIf="!isLoading" class="photos-container">
    <!-- Header section -->
    <div class="d-flex justify-content-between align-items-center gap-3 p-3 border-bottom">
      <h4 class="m-0" i18n>Property Photos</h4>
      <div class="flex-fill"></div>
      <mat-form-field2 [showLabel]="false" style="width: 300px">
        <app-select
          [items]="units"
          bindLabel="name"
          bindValue="unit_id"
          [formControl]="unitCtrl"
          [multiple]="false"
          [showBlankItem]="true"
          blankLabel="All Photos"
          placeholder="All Photos"
          i18n-placeholder
        >
          <ng-template selectLabel let-items="items">
            <ng-container *ngFor="let item of items">
              {{ item.name }} -
              <span class="text-light text-sm">{{ getUnitPhotosCount(item.unit_id, photos) }} photos</span>
            </ng-container>
          </ng-template>
          <ng-template selectItem let-item="item">
            {{ item.name }} -
            <span class="text-light text-sm">{{ getUnitPhotosCount(item.unit_id, photos) }} photos</span>
          </ng-template>
        </app-select>
      </mat-form-field2>
      <button
        class="btn btn-secondary-primary"
        (click)="onRefresh()"
        i18n-matTooltip
        matTooltip="Refresh List"
        matTooltipPosition="above"
      >
        <i class="far fa-sync"></i>
      </button>
      <div class="btn-group dropdown" role="group" dropdown [isDisabled]="1 | isReadonlyRole">
        <button
          dropdownToggle
          type="button"
          class="btn btn-secondary-warning dropdown-toggle"
          i18n-matTooltip
          matTooltip="You can perform multiple actions using this button"
        >
          <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
          <li>
            <button (click)="onBatchDelete()" type="button" [disabled]="!photoGrid?.selectedPhotos?.size">
              <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete Photos</ng-container>
            </button>
          </li>
          <li>
            <button (click)="onAddToRoomUnitGallery()" type="button" [disabled]="!photoGrid?.selectedPhotos?.size">
              <i class="fas fa-door-open"></i> <ng-container i18n>Add to Room Gallery</ng-container>
            </button>
          </li>
          <li>
            <button (click)="onAddToPropertyGallery()" type="button" [disabled]="!photoGrid?.selectedPhotos?.size">
              <i class="fas fa-home"></i> <ng-container i18n>Add to Property Gallery</ng-container>
            </button>
          </li>
        </ul>
      </div>
      <button class="btn btn-secondary-info" (click)="onAddPhotos()" [disabled]="isFraud">
        <i class="fas fa-plus"></i> <ng-container i18n>Add Photos</ng-container>
      </button>
    </div>

    <div class="p-3">
      <!-- Regular Photos -->
      <ng-container *ngIf="filteredPhotos.length > 0">
        <app-photo-grid
          #photoGrid
          [propertyId]="propertyId"
          [photos]="filteredPhotos"
          [showSelection]="true"
          [showDelete]="true"
          (delete)="onDeletePhoto($event)"
        ></app-photo-grid>
      </ng-container>

      <!-- Pending Photos -->
      <ng-container *ngIf="pendingPhotos.length > 0">
        <h5 class="mb-3 mt-4" i18n>Pending Photos</h5>
        <app-photo-grid
          #pendingPhotoGrid
          [propertyId]="propertyId"
          [photos]="pendingPhotos"
          [showSelection]="false"
          [showDelete]="false"
          [showTags]="false"
        ></app-photo-grid>
      </ng-container>

      <app-empty-table *ngIf="!isLoading && photos.length === 0 && pendingPhotos.length === 0">
        <img class="empty-image" src="assets/images/empty_icons/bdc-photo.svg" />
        <h5 class="empty-header" i18n>Showcase Your Property with Stunning Photos</h5>
        <p>
          <ng-container i18n
            >Upload captivating images to highlight your rental’s best features and attract more guests
            effortlessly.</ng-container
          >&nbsp; <a href="javascript:void(0)" (click)="onAddPhotos()" i18n>Click here</a>&nbsp;
          <ng-container i18n>to add your first photo and enhance your listing today.</ng-container>
        </p>
      </app-empty-table>
    </div>
  </div>
</div>

<ng-template #photoCard let-photo let-pending="pending">
  <div class="photo-card" [class.selected]="!pending && isPhotoSelected(photo)">
    <div class="photo-wrapper">
      <div class="photo-checkbox" *ngIf="!pending">
        <mat-checkbox [checked]="isPhotoSelected(photo)" (change)="onSelectPhoto(photo)" color="primary">
        </mat-checkbox>
      </div>
      <img [src]="photo.sample || photo.url" [alt]="photo.name" class="photo-image" />
      <div class="photo-overlay" *ngIf="!pending">
        <button class="btn btn-sm btn-danger" (click)="onDeletePhoto(photo)">
          <i class="fas fa-trash"></i>
        </button>
      </div>
      <div class="photo-metadata" *ngIf="!pending">
        <small class="photo-name">{{ photo.name }}</small>
        <div class="d-flex gap-2 align-items-center flex-wrap">
          <small
            class="badge"
            [ngClass]="{
              'bg-success': photo.quality?.toLowerCase() === 'high',
              'bg-warning text-dark': photo.quality?.toLowerCase() === 'medium',
              'bg-danger': photo.quality?.toLowerCase() === 'low'
            }"
          >
            <span i18n>Quality:</span> {{ photo.quality }}
          </small>
          <small class="badge bg-secondary">{{ photo.width }} x {{ photo.height }}</small>
        </div>
      </div>
      <div class="photo-message-tooltip" *ngIf="photo.message || photo.status_message">
        <i
          class="fas fa-info-circle"
          [matTooltip]="photo.message || photo.status_message"
          matTooltipPosition="left"
        ></i>
      </div>
    </div>
    <div class="photo-details" *ngIf="!pending">
      <div class="tags-section mt-2">
        <app-form-tags2
          [value]="photo.tag_ids || []"
          [items]="availableTags"
          [bindLabel]="'tag'"
          [bindValue]="'id'"
          [placeholder]="'Add tags'"
          [searchable]="true"
          [addNewTag]="false"
          (valueChange)="onTagsChange(photo, $event)"
        ></app-form-tags2>
      </div>
    </div>
  </div>
</ng-template>
